module.exports = __webpack_public_path__ + "static/media/hair (25).f522f024.jpg";